import { AxiosError } from "axios";

import { ADMIN_API_ENDPOINTS } from "@/config/apiEndpoints/adminUrls";
import { handleApiError } from "@/lib/utils";
import type { ILatestBlogs, ILatestBlogsMetadata } from "@/types/page";
import adminAxios from "@/lib/axios";

export async function createLatestBlog(payload: Partial<ILatestBlogs>) {
  try {
    const response = await adminAxios.post(
      ADMIN_API_ENDPOINTS.LATEST_BLOG.CREATE,
      payload
    );

    return response?.status === 201 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function updateLatestBlog(id: number, payload: Partial<ILatestBlogs>) {
  try {
    const response = await adminAxios.put(
      ADMIN_API_ENDPOINTS.LATEST_BLOG.UPDATE(id),
      payload
    );

    return response?.status === 200 ? response?.data : null;
  } catch (error) {
    const errorResponse = handleApiError(error as AxiosError);
    return errorResponse ? errorResponse : null;
  }
}

export async function fetchLatestBlogSources(pageId: number): Promise<ILatestBlogsMetadata[]> {
  try {
    const response = await adminAxios.get<{ success: boolean; data: ILatestBlogsMetadata[] }>(
      ADMIN_API_ENDPOINTS.LATEST_BLOG.SOURCES(pageId)
    );
    if (response?.status !== 200 || response.data?.success !== true) {
      return [];
    }
    const rows = response.data.data;
    return Array.isArray(rows) ? rows : [];
  } catch (error) {
    const errResp = handleApiError(error as AxiosError);
    throw new Error(errResp?.message ?? "Failed to load blog posts");
  }
}
